<template>
  <div>
    <SearchFacetOptions
      :entityType="'Instrument'"
      :options="agreementTypeOptions"
      :title="'Agreement Type'"
      :fieldName="'agreementTypes'"
      :loading="agreementTypeOptionsLoading"
    />
    <SearchFacetOptions
      :entityType="'Instrument'"
      :options="instrumentTypeOptionsWithCode"
      :title="'Instrument Type'"
      :fieldName="'instrumentTypes'"
      :loading="instrumentTypeLoading"
    />
    <SearchFacetOptions
      :entityType="'Instrument'"
      :options="instrumentTagOptions"
      :title="'Tags'"
      :fieldName="'instrumentTags'"
      :loading="instrumentTagsLoading"
    />
    <SearchFacetOptions
      :entityType="'Instrument'"
      :options="instrumentStatusOptions"
      :title="'Instrument Status'"
      :fieldName="'instrumentStatuses'"
      :loading="instrumentStatusOptionsLoading"
    />
    <SearchFacetOptions
      :entityType="'Instrument'"
      :options="instrumentStaffLeadNames"
      :title="'Staff Lead'"
      :fieldName="'staffLeads'"
      :loading="instrumentStaffLeadLoading"
      :onlyOneAllowed="false"
      :key="radioButtonFacetKey"
    />
    <SearchFacetOptions
      :entityType="'Instrument'"
      :options="localityOptions"
      :title="'Locality'"
      :fieldName="'localities'"
      :loading="localityLoading"
    />
    <SearchFacetOptions
      :entityType="'Instrument'"
      :options="grantProgramOptions"
      :title="'Grant Program'"
      :fieldName="'grantPrograms'"
      :loading="grantProgramOptionsLoading"
    />
    <EventTypeSearchFacets
      :key="eventTypeFacetKey"
    />
    <ContactSearchFacets />
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { LookupModules } from '@/store/moduleConfig';
import ContactSearchFacets from '@/components/search/ContactSearchFacets.vue';
import SearchFacetOptions from '@/components/search/SearchFacetOptions.vue';
import EventTypeSearchFacets from '@/components/search/EventTypeSearchFacets.vue';

export default {
  name: 'InstrumentSearchFacets',
  components: {
    ContactSearchFacets,
    EventTypeSearchFacets,
    SearchFacetOptions,
  },
  props: {
    radioButtonFacetKey: {
      type: Number,
    },
  },
  computed: {
    ...mapState('Instrument', {
      instrumentStaffLeadNames: state => state.distinctStaffLeadNames,
      instrumentStaffLeadLoading: state => state.distinctStaffLeadNamesLoading,
    }),
    ...mapState(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypeOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.GRANT_PROGRAMS.namespace, {
      grantProgramOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_STATUSES.namespace, {
      instrumentStatusOptionsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_TYPES.namespace, {
      instrumentTypeLoading: state => state.loading,
    }),
    ...mapState(LookupModules.INSTRUMENT_TAGS.namespace, {
      instrumentTagsLoading: state => state.loading,
    }),
    ...mapState(LookupModules.LOCALITIES.namespace, {
      localityLoading: state => state.loading,
    }),
    ...mapGetters(LookupModules.AGREEMENT_TYPES.namespace, {
      agreementTypeOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.GRANT_PROGRAMS.namespace, {
      grantProgramOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_STATUSES.namespace, {
      instrumentStatusOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_TYPES.namespace, {
      instrumentTypeOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.INSTRUMENT_TAGS.namespace, {
      instrumentTagOptions: 'getActiveOptions',
    }),
    ...mapGetters(LookupModules.LOCALITIES.namespace, {
      localityOptions: 'getActiveOptions',
    }),
    // created this so we do not have key clashes between different facets w/ radiobuttons
    eventTypeFacetKey() {
      return this.radioButtonFacetKey + 400;
    },
    instrumentTypeOptionsWithCode() {
      return this.instrumentTypeOptions.map(iso => ({
        id: iso.id,
        name: `${iso.name} (${iso.code})`,
      }));
    },
  },
  mounted() {
    // dispatch actions to populate vuex state for this page
    this.$store.dispatch('Instrument/fetchStaffLeadNames');
    this.$store.dispatch(`${LookupModules.AGREEMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.AGREEMENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.GRANT_PROGRAMS.namespace}/fetchOptions`,
      LookupModules.GRANT_PROGRAMS.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_ROLES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_ROLES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_STATUSES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_STATUSES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_TYPES.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_TYPES.url);
    this.$store.dispatch(`${LookupModules.INSTRUMENT_TAGS.namespace}/fetchOptions`,
      LookupModules.INSTRUMENT_TAGS.url);
    this.$store.dispatch(`${LookupModules.LOCALITIES.namespace}/fetchOptions`,
      LookupModules.LOCALITIES.url);
  },
};
</script>
